const __WEBPACK_NAMESPACE_OBJECT__ = { AsyncLocalStorage: function() {} };